import { LOGISTICS_QUOTE_URL } from 'features';
import { PriceAndCurrencyField, TextField } from 'form';
import { Button, Grid, Stack, Typography } from 'ui';

import type { TransportPriceEstimateError } from '../../types';
import { assemblerHelperTransportPriceText } from '../../utils/assembleHelperText/assembleHelperText';

type Props = {
  onTransportPriceUpdate: () => void;
  transportPriceError: TransportPriceEstimateError;
};

export const TransportCostDrawerSection = ({ onTransportPriceUpdate, transportPriceError }: Props) => {
  const helperTransportPriceText = assemblerHelperTransportPriceText(transportPriceError);

  return (
    <Stack direction="column" gap={2}>
      <Typography variant="body2" fontWeight="bold">
        Transport cost
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <PriceAndCurrencyField
            label="Transport cost per load"
            priceName="transport_cost"
            currencyName="transport_currency"
            fullWidth
            slotProps={{
              currency: {
                onChange: onTransportPriceUpdate,
              },
              price: {
                error: Boolean(helperTransportPriceText),
                helperText: helperTransportPriceText,
                onChange: onTransportPriceUpdate,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField name="tonnes_per_load" label="Tonnes per load" type="number" />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField name="number_of_loads" label="Number of loads" type="number" />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField name="estimated_transit_time_days" label="Estimated transit (days)" type="number" disabled />
        </Grid>
        <Grid item xs={12} md={2}>
          <Button variant="secondary" component="a" href={LOGISTICS_QUOTE_URL} target="_blank">
            Request Quote
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};
